import { Component, Input, OnInit } from '@angular/core';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {
  RolloverResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover.result';
import {
  RolloverPropertyTransferredResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover-property-transferred.result';

@Component({
  selector: 'app-rollover-capital-gain-result',
  templateUrl: './rollover-capital-gain-result.component.html',
  styleUrls: ['./rollover-capital-gain-result.component.scss'],
  standalone: false,
})
export class RolloverCapitalGainResultComponent implements OnInit {

  @Input()
  options: RolloverOptions;
  @Input()
  results: RolloverResult;
  @Input()
  propertyTransferredResults: RolloverPropertyTransferredResult;

  isSectionCapitalGainCollapsed: boolean = false;

  @Input()
  selectedBadge: string;

  ngOnInit() {
  }
}
